"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
let ChangeColorConfig = class extends Vue {
  constructor() {
    super(...arguments);
    this.checkColor = "normal";
    this.clientColor = "ordinary";
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.get_color();
      yield this.init_client_color();
    });
  }
  init_client_color() {
    return __async(this, null, function* () {
      try {
        let res = yield API.get(`api://base.local/storages/preference/client_color`);
        this.clientColor = res.data.value.color;
      } catch (error) {
        let clienColor = "ordinary";
        yield API.put(`api://base.local/storages/preference/client_color`, {
          color: clienColor
        });
      }
    });
  }
  get_color() {
    return __async(this, null, function* () {
      try {
        let res = yield API.get(`api://base.local/storages/preference/theme_color`);
        this.checkColor = res.data.value.color;
      } catch (error) {
        let checkColor = "normal";
        yield API.put(`api://base.local/storages/preference/theme_color`, {
          color: checkColor
        });
      }
    });
  }
  handleClientColor() {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.local/storages/preference/client_color`, {
          color: this.clientColor
        });
        this.$message.success(this.$t("changecolor.change_client_success"));
      } catch (error) {
      }
    });
  }
  handleColorChange() {
    return __async(this, null, function* () {
      try {
        yield API.post(`api://base.local/websockets/main`, {
          "model": "settingEvent.setting.theme.change",
          "value": {
            message: "theme.change",
            color: this.checkColor
          }
        });
        yield API.put(`api://base.local/storages/preference/theme_color`, {
          color: this.checkColor
        });
        let loading = this.$loading({
          lock: true,
          fullscreen: true,
          text: this.$t("changecolor.loading"),
          customClass: "hard-loading",
          background: "rgba(0, 0, 0, 0.8)"
        });
        yield new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve(true);
          }, 2e3);
        });
        loading.close();
      } catch (error) {
        yield this.get_color();
      }
    });
  }
};
ChangeColorConfig = __decorateClass([
  Component
], ChangeColorConfig);
export {
  ChangeColorConfig as default
};
